<template>
  <modal
    :show.sync="detailModalSync"
    bodyClasses="px-4"
    headerClasses="bg-success"
    cardClasses=""
    modalClasses=""
    @close="closeDetails"
    v-if="detailModalSync"
  >
    <template slot="header">
      <p class="lead font-weight-bold text-light mb-0">
        <i class="nc-icon nc-zoom-split" aria-hidden="true"></i>:
        {{ showingLog.detalleHistorial }}
      </p>
    </template>
    <div class="text-secondary">
      <p class="lead mb-2 border-bottom">Detalle Modificacion</p>
      <div class="row px-2">
        <p class="col-4 mb-1">Responsable</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">{{ showingLog.responsableModificacion }}</p>
      </div>
      <div class="row px-2 mb-2">
        <p class="col-4 mb-1">Fecha</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          {{
            validateDate(showingLog.fechaIngresoHistorial)
              ? showingLog.fechaIngresoHistorial
              : $moment(showingLog.fechaIngresoHistorial).format(
                  "DD-MM-YYYY HH:mm:ss"
                )
          }}
        </p>
      </div>
      <p class="lead mb-2 border-bottom">Detalle Membresía</p>
      <div class="row px-2">
        <p class="col-3 mb-1">Nombre</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          [{{ showingLog.idPlan }}] - {{ showingLog.descripcionPlan }}
        </p>
      </div>
      <div class="row px-2">
        <p class="col-3 mb-1">Familia</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          [{{ showingLog.idFamilia }}] - {{ showingLog.nombreFamilia }}
        </p>
      </div>
      <div class="row px-2">
        <p class="col-3 mb-1">Sub-Familia</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          [{{ showingLog.idSubFamilia }}] - {{ showingLog.nombreSubFamilia }}
        </p>
      </div>
      <div class="row px-2">
        <p class="col-3 mb-1">Turno</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          [{{ showingLog.codigoTurno }}] - {{ showingLog.descripcionTurno }}
        </p>
      </div>
      <div class="row px-2">
        <p class="col-3 mb-1">Estado</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">{{ showingLog.estadoPago }}</p>
      </div>
      <div class="row px-2">
        <p class="col-3 mb-1">Congelar</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          {{ showingLog.diasPermitidoCongelar || 0 }} Días
        </p>
      </div>
      <div class="row px-2">
        <p class="col-3 mb-1">Duración</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          {{ showingLog.duracionPlan || "" }}
          {{ showingLog.unidadDuracionPlan.glosa }}
        </p>
      </div>
      <hr class="px-5 mx-5" />
      <div class="row px-2">
        <div class="col-6 d-flex flex-row px-0">
          <p class="col-3 mb-1">Tipo</p>
          <p class="w-auto mb-1">:</p>
          <p class="pl-2 mb-1">{{ showingLog.convenio.glosa }}</p>
        </div>
        <div class="col-6 d-flex flex-row px-0">
          <p class="col-3 mb-1">IVA</p>
          <p class="w-auto mb-1">:</p>
          <p class="pl-2 mb-1">{{ showingLog.tipoIVA }}</p>
        </div>
      </div>
      <hr class="px-5 mx-5" />
      <div class="row px-2">
        <div class="col-12 col-md-6 d-flex flex-row px-0">
          <p class="col-auto mb-1">Permite renovar</p>
          <p class="w-auto mb-1">:</p>
          <p class="pl-2 mb-1">
            {{ showingLog.indicadorPermiteRenovar ? "SI" : "NO" }}
          </p>
        </div>
        <div class="col-12 col-md-6 d-flex flex-row px-0">
          <p class="col-auto mb-1">Expiración</p>
          <p class="w-auto mb-1">:</p>
          <p class="pl-2 mb-1">
            {{ showingLog.expiracionRenovacion || null }}
            {{ showingLog.unidadExpiracionRenovacion.glosa }}
          </p>
        </div>
      </div>
      <hr class="px-5 mx-5" />
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Inicio</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.fechaInicio || "" }}
            </p>
          </div>
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Vencimiento</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.fechaVencimiento || "" }}
            </p>
          </div>
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Vigencia</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.fechaVigencia || "" }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Asignación</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{
                $moment(showingLog.fechaAsignacion).format("DD-MM-YYYY") ||
                ""
              }}
            </p>
          </div>
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Pago</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.fechaUltimoPago || "" }}
            </p>
          </div>
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Vigencia</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.fechaVigencia || "" }}
            </p>
          </div>
        </div>
      </div>
      <hr class="px-5 mx-5" />
      <div class="row px-2">
        <p class="col-3 mb-1">Sesiones</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          {{ showingLog.indicadorUsoSesiones ? "SI" : "NO" }}
        </p>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Consumidas</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.sesionesUtilizadas }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Max.</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.sesionesLimite }}
            </p>
          </div>
        </div>
      </div>
      <hr class="px-5 mx-5" />
      <div class="row px-2">
        <p class="col-3 mb-1">Matricula</p>
        <p class="w-auto mb-1">:</p>
        <p class="pl-2 mb-1">
          {{ showingLog.indicadorMatricula ? "SI" : "NO" }}
        </p>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row px-2">
            <p class="col-6 mb-1 pl-0 pl-3">Valor</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.valorMatricula }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row px-2">
            <p class="col-auto mb-1 pl-0 pl-3">Fecha Pago</p>
            <p class="w-auto mb-1">:</p>
            <p class="pl-2 mb-1">
              {{ showingLog.fechaPagoMatricula || "" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
export default {
  name: "CustomerMembershipLogDetail",
  props: {
    detailModalSync: {
      type: Boolean,
      default: false, //Cambiar a false
    },
    showingLog: {
      type: Object,
      default: () => {
        return {
          detalleHistorial: "Modificacion de membresía",
          responsableModificacion: "Usuario",
          fechaIngresoHistorial: "16-04-2024 10:38:59",
          unidadDuracionPlan: {},
          unidadExpiracionRenovacion: {},
          estadoPago: {},
        }; //Cambiar a false
      },
    },
  },
  components: {
    Badge,
    CollapseItem,
    Collapse,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  methods: {
    closeDetails() {
      this.$emit("closeDetails");
    },
    validateDate(dateTime) {
      const regex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
      return regex.test(dateTime);
    },
  },
};
</script>

<style></style>
